import type { Screen } from "../../app/api/ApiClient";
import type { StateStore } from "../../app/state/StateStore";

import { ScreenMapper } from "./ScreenMapper";

type SubscriptionsScreen =
    Extract<Screen, { type: "subscriptions" }>;

export class SubscriptionsScreenMapper
    implements ScreenMapper<SubscriptionsScreen> {

    public readonly type = "subscriptions" as const;

    constructor(
        private readonly store: StateStore
    ) {}

    public apply(
        screen: SubscriptionsScreen
    ): void {

        const state =
            this.store.getState();

        this.store.replace({

            ...state,

            primaryScreen: {

                type: "subscriptions"

            },

            stickers:
                screen.available_stickers ?? [],

            currentSticker:
                screen.current_sticker ?? null,

            productTitle:
                screen.product_title ?? null,

            isLoading: false

        });

    }

}